<template>
  <div class="introducePage">
    <a-row :gutter="[20,0]" type="flex" justify="space-between">
        <a-col :xs="24" :sm="24" :md="24" :lg="10" style="position: relative;">
            <p class="jj">课程简介</p>
            <div class="jj_img"></div>
            <div class="jj_num">
                <p class="jj_num_num">7</p>
                <p class="jj_num_text">
                    核心知识点<br/>机械-编程-物理-数学
                </p>
            </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="13">
            <div class="courseDescBox">
                <p v-html="info.courseDesc"></p>
            </div>
        </a-col>
    </a-row>
  </div>
</template>
<script>
export default {
    props:['details'],
    watch:{
        details:{
            handler(obj){
                this.info=obj
            },
            immediate:true,
            deep:true
        }
    },
  name: "introducePage",
  components: {},
  data() {
    return {
        info:''
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang='less' scoped>
.introducePage {
    width: 100%;
    padding: 20px;
    max-width: 1200px;
    min-height: 500px;
    height: auto;
    background: #000;
    border-radius: 20px;
    margin: 60px auto;
    margin-bottom: 0;
    .jj{
        font-size: 24px;
        color: #fff;
        line-height: 30px;
    }
    .jj_img{
        width: 90%;
        height: 410px;
        margin: 0 auto;
        background-image: url('~@/theme/wayi/assets/imgs/course/NL.gif');
        background-size: 100% 100%;
    }
    .jj_num{
        width: 160px;
        height: 180px;
        padding: 30px 0;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 9;
        background:var(--primary-color);
        border-radius: 5px;
        .jj_num_num{
            font-size: 48px;
            color: #fff;
            text-align: center;
            margin: 0;
        }
        .jj_num_text{
            font-size: 14px;
            text-align: center;
            margin: 0;
            color: #fff;
        }
    }
    .courseDescBox{
        width: 100%;
        max-height: 460px;
        height: auto;
        overflow-y: auto;
        color: #fff;
        padding: 30px 10px;
    }
    .courseDescBox::-webkit-scrollbar{
        display: none;
    }
}
</style>
